export default "<!--  my page  -->"